import React from 'react';
import { Button, IconExternalLink } from 'gatorcomponents';
import * as Styles from './ServerTypeSelector.styles';

const ServerTypeSelector = ({
  locale, onSelectVPS, onSelectDedicated,
}) => (
  <Styles.Container data-testid="server-type-selector-container">
    <Styles.CardsWrapper>
      <Styles.Card data-testid="server-type-vps-card">
        <Styles.CardTitle data-testid="server-type-vps-title">{locale.vps.title}</Styles.CardTitle>
        <Styles.CardDescription data-testid="server-type-vps-description">{locale.vps.description}</Styles.CardDescription>
        <Button
          label={locale.vps.button}
          variant="primary"
          size="large"
          version="v2"
          width="full"
          iconRight={(
            <IconExternalLink
              color="highPure"
              secondaryColor="transparent"
              size="sm2"
            />
          )}
          notFillSVG
          onClick={onSelectVPS}
          testId="server-type-vps-button"
        />
      </Styles.Card>

      <Styles.Card data-testid="server-type-dedicated-card">
        <Styles.CardTitle data-testid="server-type-dedicated-title">{locale.dedicated.title}</Styles.CardTitle>
        <Styles.CardDescription data-testid="server-type-dedicated-description">{locale.dedicated.description}</Styles.CardDescription>
        <Button
          label={locale.dedicated.button}
          variant="primary"
          size="large"
          version="v2"
          width="full"
          iconRight={(
            <IconExternalLink
              color="highPure"
              secondaryColor="transparent"
              size="sm2"
            />
          )}
          notFillSVG
          onClick={onSelectDedicated}
          testId="server-type-dedicated-button"
        />
      </Styles.Card>
    </Styles.CardsWrapper>
  </Styles.Container>
);

export default ServerTypeSelector;
